import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-200 rounded-xl px-5 py-3.5 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-accent-400 focus:border-accent-400 transition-all duration-200"
            >
              <option value="">{t('categories.choose')}</option>
              {categories.map((cat) => (
                <option key={cat.seq} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-foreground-500"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col items-center justify-center p-4 md:p-5 rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mb-2 md:mb-3 rounded-full bg-accent-100/80 group-hover:bg-accent-200/80 transition-colors duration-200">
                <i className="ri-shopping-bag-3-line text-lg md:text-xl text-accent-600"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-950 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}